import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { rootReducer as sharedRootReducer, sharedMiddleware } from '@senderra/shared';
import { preferencesApi } from './app/features/preferences/api/preferencesApi';
import { reportsApi } from './app/features/reports/api/reportsApi';
import { tenantUsageTrackerApi } from '@senderra/shared/features/usage-tracker/api/tenantUsageTrackerApi';

export const rootReducer = combineReducers({
    ...sharedRootReducer,
    [preferencesApi.reducerPath]: preferencesApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [tenantUsageTrackerApi.reducerPath]: tenantUsageTrackerApi.reducer,
});

export const middlewares = [reportsApi.middleware, preferencesApi.middleware, tenantUsageTrackerApi.middleware, ...sharedMiddleware];

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
